export const isCurrentBrowserIOS =
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.userAgent.includes('Macintosh') && 'ontouchend' in document) ||
  !('MediaSource' in window && MediaSource?.isTypeSupported('video/mp4; codecs="avc1.640028, mp4a.40.2"'));

export const isCurrentBrowserMacOSSafari =
  /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && !('ontouchend' in document);
